import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EntryParamsService {
  private readonly _previousFundId = signal<string | null>(null);
  readonly previousFundId = this._previousFundId.asReadonly();

  capturePreviousFundId(value: string | null | undefined): void {
    if (value && !this._previousFundId()) {
      this._previousFundId.set(value);
    }
  }

  consumePreviousFundId(): string | null {
    const value = this._previousFundId();
    this._previousFundId.set(null);
    return value;
  }
}
